export default __webpack_public_path__ + "locales/sl/PrivacyPage.json?hash=1eb66a92a27340070980ac253cf51546";